<script lang="ts">
	import detailIcon from "@assets/icons/detail.svg?raw";
	import type { EmblaPluginType } from "embla-carousel";
	import autoplay from "embla-carousel-autoplay";
	import type { Review } from "../../data/homepageData.js";
	import Carousel from "./Carousel.svelte";
	import Link from "./Link.svelte";
	import ReviewCard from "./ReviewCard.svelte";
	import { ButtonVariant } from "./getButtonClass.js";

	const { reviews, showButton = true }: { reviews: Review[]; showButton?: boolean } = $props();

	const autoplayPlugin: EmblaPluginType = autoplay({
		delay: 5000,
		stopOnInteraction: false,
		stopOnMouseEnter: true,
		playOnInit: true,
	});
</script>

<section class="full-width flex flex-col items-center gap-8 md:gap-20 py-16">
	<Carousel
		items={reviews}
		options={{ loop: true, align: "center", containScroll: false }}
		plugins={[autoplayPlugin]}
		class="w-full"
		itemsContainerClass="flex items-stretch"
	>
		{#snippet item(review: Review)}
			<ReviewCard {review} />
		{/snippet}
	</Carousel>

	{#if showButton}
		<div class="flex justify-center">
			<Link href="/procedury" variant={ButtonVariant.PrimaryMedium} iconStart={detailIcon}>
				Chci si vybrat proceduru
			</Link>
		</div>
	{/if}
</section>
